import { Stack } from "@certa/catalyst/layouts/Stack";
import {
  Ellipsis,
  Typography,
  TypographyColors,
  TypographyVariants
} from "@certa/catalyst/components/Typography";
import { css } from "emotion";
import { extractAttachmentName } from "../../comments.utils";
import { Download } from "@certa/icons/components/Download";
import { CatalystColors } from "@certa/catalyst/constants/styles";

type AttachmentViewProps = {
  attachment: string;
  isPostedByCurrentUser: boolean;
};

const AttachmentView = ({
  attachment,
  isPostedByCurrentUser
}: AttachmentViewProps) => {
  if (!attachment) return null;
  return (
    <Stack
      direction="horizontal"
      justify={isPostedByCurrentUser ? "flex-end" : "flex-start"}
      dangerouslySetClassName={css({
        margin: "var(--space-4) 0"
      })}
    >
      <a
        href={attachment}
        className={css({
          textDecoration: "none !important",
          marginRight: "0.25rem",
          color: "unset !important",
          minWidth: 0,
          ":focus": {
            outline: `2px solid ${CatalystColors.BRAND_400}`,
            borderRadius: "0.75rem"
          }
        })}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Stack
          direction="horizontal"
          align="center"
          gap="4"
          backgroundColor={CatalystColors.NEUTRAL_100}
          padding="12"
          dangerouslySetClassName={css({
            minWidth: 0,
            border: `1px solid ${CatalystColors.NEUTRAL_400}`,
            borderRadius: "0.75rem"
          })}
        >
          <Download size={12} className={css({ flexShrink: 0 })} />
          <Typography
            variant={TypographyVariants.LABEL_SM_BOLD}
            color={TypographyColors.NEUTRAL_800}
            style={{
              minWidth: 0
            }}
          >
            <Ellipsis>{extractAttachmentName(attachment)}</Ellipsis>
          </Typography>
        </Stack>
      </a>
    </Stack>
  );
};

export { AttachmentView };
